import { render, staticRenderFns } from "./ManageCustomer.vue?vue&type=template&id=1eb36888&scoped=true"
import script from "./ManageCustomer.vue?vue&type=script&lang=js"
export * from "./ManageCustomer.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomer.vue?vue&type=style&index=0&id=1eb36888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb36888",
  null
  
)

export default component.exports